import { differenceInMinutes } from 'date-fns';

const PROD_STACK_MANAGER_AUTH_TIMESTAMP = 'prodStackManagerAuthTimestamp';

export const setAuthTimestamp = (authTimestamp: string) => {
  return localStorage.setItem(PROD_STACK_MANAGER_AUTH_TIMESTAMP, authTimestamp);
};

export const getAuthTimestamp = () => {
  return localStorage.getItem(PROD_STACK_MANAGER_AUTH_TIMESTAMP);
};

export const removeAuthTimestamp = () => {
  localStorage.removeItem(PROD_STACK_MANAGER_AUTH_TIMESTAMP);
};

export const isAuthTimestampExpired = (authTimestamp: string) => {
  const minutes = differenceInMinutes(new Date(), new Date(authTimestamp));

  return minutes > 5;
};
